/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-const */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { useForm } from 'react-hook-form';
import Image from 'next/image';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import arrow from '../../../public/assets/down-arrow.svg';
import calendar from '../../../public/assets/calendar.svg';
import CREATE_SLOT_BOOKING from '../../gql/mutations/slot-booking.gql';
import SuccessFormPopup from '../profile/forms/SuccessFormPopup';
import { ToastContext } from '../../contexts/toast-context-with-provider';
import { trackEvent } from '../../utils/analytics';
import EventNames from '../../utils/event-name-constants';
import { useUser } from '../../contexts/ssr-user-context';

function parseTimeToMinutes(timeStr) {
  const [time, modifier] = timeStr.split(' ');
  let [hours, minutes] = time.split(':').map(Number);
  if (modifier === 'PM' && hours !== 12) hours += 12;
  if (modifier === 'AM' && hours === 12) hours = 0;
  return hours * 60 + minutes;
}

function getTodayStr() {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function SlotBookingForm({
  slotBookingData, slotBookings, domainName, refetch,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm({ mode: 'onChange' });
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const dateInputRef = useRef(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [isRescheduleDisabled, setIsRescheduleDisabled] = useState(false);
  const [unit, setUnit] = useState('');
  const { showToast } = useContext(ToastContext);
  const [initialFormValues, setInitialFormValues] = useState(null);
  const { user } = useUser();
  const handleRefetchBookingData = () => {
    setPopupOpen(false);
    refetch();
  };

  useEffect(() => {
    if (slotBookings) {
      setPopupOpen(true);
      setMsg(`Academic Counselling Session with ${domainName.organizationName === 'nextias' ? 'NEXT IAS' : 'MADE EASY'}`);
    }
  }, [slotBookings, domainName]);

  useEffect(() => {
    if (slotBookings) {
      reset({
        slotDate: slotBookings?.slotDate || '',
        slotTime: slotBookings?.slotTime || '',
        mode: slotBookings?.mode ? (slotBookings?.mode.charAt(0).toUpperCase() + slotBookings?.mode.slice(1)) : '',
        center: slotBookings?.center || '',
        course: slotBookings?.course || '',
      });
      setSelectedTime(slotBookings?.slotTime || '');
      setInitialFormValues({
        slotDate: slotBookings?.slotDate || '',
        slotTime: slotBookings?.slotTime || '',
        mode: slotBookings?.mode ? (slotBookings?.mode.charAt(0).toUpperCase() + slotBookings?.mode.slice(1)) : '',
        center: slotBookings?.center || '',
        course: slotBookings?.course || '',
      });
    } else {
      const todayStr = getTodayStr();
      reset({
        slotDate: todayStr, slotTime: '', mode: '', center: '', course: '',
      });
      setSelectedTime('');
      setInitialFormValues({
        slotDate: todayStr, slotTime: '', mode: '', center: '', course: '',
      });
    }
  }, [slotBookings, reset]);

  useEffect(() => {
    if (slotBookings && slotBookings?.createdAt && slotBookingData?.validFor) {
      const validForStr = slotBookingData?.validFor;
      let validForMs = 0;

      if (typeof validForStr === 'string') {
        const valiForUnit = validForStr.slice(-1);
        const value = parseInt(validForStr.slice(0, -1), 10);

        const numericValue = Number(value);
        if (!Number.isNaN(numericValue)) {
          switch (valiForUnit) {
            case 'h':
              validForMs = value * 60 * 60 * 1000;
              setUnit('hours');
              break;
            case 'm':
              validForMs = value * 60 * 1000;
              setUnit('minutes');
              break;
            case 's':
              validForMs = value * 1000;
              setUnit('seconds');
              break;
            default:
              console.warn(`Unknown time unit: ${valiForUnit}`);
          }
        }
      }

      const createdAt = slotBookings?.createdAt;
      const expiryTime = createdAt + validForMs;
      const now = Date.now();
      setIsRescheduleDisabled(now > expiryTime);
    } else {
      setIsRescheduleDisabled(false);
    }
  }, [slotBookings, slotBookingData]);

  const [createSlotBooking, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_SLOT_BOOKING);

  const fields = slotBookingData?.fields || [];
  const watchedFields = watch();
  const selectedMode = watch('mode');
  const selectedCenter = watch('center');
  const selectedDate = watch('slotDate');

  const prevDateRef = useRef();
  useEffect(() => {
    if (prevDateRef.current !== undefined && prevDateRef.current !== selectedDate) {
      setSelectedTime('');
      setValue('slotTime', undefined);
    }
    prevDateRef.current = selectedDate;
  }, [selectedDate, setValue]);

  let slotTimeOptions = [];
  let centerDisplay = '';
  if (
    selectedMode === 'Offline'
    && selectedCenter
    && slotBookingData?.slotTime
    && slotBookingData?.slotTime[selectedCenter]
  ) {
    slotTimeOptions = slotBookingData?.slotTime[selectedCenter]?.slots || [];
    centerDisplay = `${selectedCenter} - ${slotBookingData?.slotTime[selectedCenter]?.description || ''}`;
  } else if (selectedMode === 'Online') {
    slotTimeOptions = slotBookingData?.slotTime?.Online?.slots || [];
    centerDisplay = '';
  }

  const isFieldVisible = (field) => {
    if (!field?.visibleIf) return true;
    const { field: depField, equals } = field?.visibleIf;
    return watchedFields[depField] === equals;
  };

  const getDateLimits = (field) => {
    let minDate;
    let maxDate;
    if (field.minDate === 'today') {
      const minDateStr = getTodayStr();
      minDate = minDateStr;
      if (field.maxOffsetDays) {
        const today = new Date();
        const maxDateObj = new Date(today);
        maxDateObj.setDate(today.getDate() + field.maxOffsetDays);
        const yyyyMax = maxDateObj.getFullYear();
        const mmMax = String(maxDateObj.getMonth() + 1).padStart(2, '0');
        const ddMax = String(maxDateObj.getDate()).padStart(2, '0');
        const maxDateStr = `${yyyyMax}-${mmMax}-${ddMax}`;
        maxDate = maxDateStr;
      }
    }
    return { minDate, maxDate };
  };

  const hasFormChanged = () => {
    if (!initialFormValues) return true;
    const current = {
      slotDate: watch('slotDate'),
      slotTime: selectedTime || watch('slotTime'),
      mode: watch('mode'),
      center: watch('center'),
    };
    return (
      current.slotDate !== initialFormValues.slotDate
      || current.slotTime !== initialFormValues.slotTime
      || current.mode !== initialFormValues.mode
      || current.center !== initialFormValues.center
    );
  };

  const onSubmit = async (formData) => {
    if (slotBookings && isRescheduleDisabled) {
      showToast(`Rescheduling is not permitted after ${slotBookingData?.validFor.slice(0, -1)} ${unit} from booking time.`);
      return;
    }
    if (slotBookings && !hasFormChanged()) {
      showToast('Please change at least one field before rescheduling.');
      return;
    }
    try {
      const isNextIAS = domainName?.organizationName === 'nextias';
      const resolvedSlotTime = (selectedTime && selectedTime.trim())
        || (formData?.slotTime && formData.slotTime.trim())
        || (isNextIAS ? '00:00:00' : undefined);

      const result = await createSlotBooking({
        variables: {
          input: {
            scope: 'counselling',
            slotDate: formData?.slotDate,
            ...(resolvedSlotTime !== undefined && { slotTime: resolvedSlotTime }),
            mode: formData?.mode,
            center: formData?.center,
            course: formData?.course || '',
          },
        },
      });
      if (result) {
        setPopupOpen(true);
        setMsg(`Academic Counselling Session with ${domainName.organizationName === 'nextias' ? 'NEXT IAS' : 'MADE EASY'}`);
        trackEvent(EventNames.COUNSELLING_SESSION_SLOT_BOOKED, {
          timestamp: new Date().getTime(),
          accountId: user?.id,
          counsellingMode: formData?.mode,
          counsellingCenter: formData?.center,
          counsellingDate: formData?.slotDate,
          counsellingTime: resolvedSlotTime,
        });
      }
    } catch (err) {
      if (err) {
        console.error('Mutation error:', err);
      }
    }
  };

  const showError = (fieldName) => (errors[fieldName] ? (
    <span className="text-red-500 text-sm block mt-2">
      {errors[fieldName].message}
    </span>
  ) : null);

  const renderField = (field) => {
    if (!isFieldVisible(field)) return null;
    const commonProps = {
      ...register(field.name, { required: field.required ? 'This field is required' : false }),
      id: field.name,
      name: field.name,
      className: `w-full p-3 pr-10 border rounded-md outline-none bg-[#FBFCFF] text-[#33415599] ${errors[field.name] ? 'border-red-500' : 'border-[#8ACEFF]'} text-sm md:text-base`,
      defaultValue: '',
    };
    switch (field.type) {
      case 'select': {
        if (field.name === 'slotTime') {
          let slotTimeMessage = null;
          if (!selectedMode) {
            slotTimeMessage = (
              <span className="text-gray-400 text-sm md:text-base col-span-3">
                Select mode to see available slots.
              </span>
            );
          } else if (selectedMode === 'Offline' && !selectedCenter) {
            slotTimeMessage = (
              <span className="text-gray-400 text-sm md:text-base col-span-3">
                Select center to see available slots.
              </span>
            );
          } else if (slotTimeOptions.length === 0) {
            slotTimeMessage = (
              <span className="text-gray-400 text-sm md:text-base col-span-3">
                No slots available.
              </span>
            );
          }
          const today = new Date();
          const todayStr = getTodayStr();
          const currentMinutes = today.getHours() * 60 + today.getMinutes();
          return (
            <div key={field.name}>
              <label className="block font-semibold mb-2 text-sm md:text-base">
                Time*
              </label>
              <div className="grid grid-cols-3 gap-3 md:gap-6 w-full">
                {slotTimeMessage
                  || slotTimeOptions.map((time) => {
                    let isPast = false;
                    if (selectedDate === todayStr) {
                      isPast = parseTimeToMinutes(time) <= currentMinutes;
                    }
                    return (
                      <button
                        type="button"
                        key={time}
                        className={`border rounded-md px-4 py-2 md:px-5 md:py-3 font-semibold text-sm md:text-base ${selectedTime === time
                          ? 'bg-[#0267B1] text-white'
                          : isPast
                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            : 'bg-white text-black'
                        } ${selectedTime === time ? '' : !isPast ? 'hover:bg-blue-50' : ''
                        } border-[#33415599]`}
                        onClick={() => {
                          if (isPast) return;
                          setSelectedTime(time);
                          if (typeof setValue === 'function') {
                            setValue(field.name, time, { shouldValidate: true });
                          }
                        }}
                        disabled={isPast}
                      >
                        {time}
                      </button>
                    );
                  })}
              </div>
              {showError(field.name)}
            </div>
          );
        }
        const options = field.options || [];
        const handleSelectChange = (e) => {
          if (field.name === 'mode') {
            const newMode = e.target.value;
            setValue('mode', newMode);
            setValue('center', '');
            setValue('slotTime', undefined);
            setValue('course', '');
            setSelectedTime('');
          } else if (field.name === 'center') {
            const newCenter = e.target.value;
            setValue('center', newCenter);
            setValue('slotTime', undefined);
            setSelectedTime('');
          }
        };
        return (
          <div key={field.name}>
            <label htmlFor={field.name} className="block font-semibold mb-2 text-sm md:text-base">
              {field.label}
              {field.required && '*'}
            </label>
            <div className="relative">
              <select
                {...commonProps}
                onChange={
                  field.name === 'mode' || field.name === 'center'
                    ? handleSelectChange
                    : undefined
                }
              >
                <option value="" disabled>
                  {`${field.label}${field.required ? '*' : ''}`}
                </option>
                {options.map((opt) => (
                  <option key={opt.value || opt} value={opt.value || opt}>
                    {opt.label || opt}
                  </option>
                ))}
              </select>
              <span className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2">
                <Image src={arrow} alt="dropdown arrow" width={20} height={20} />
              </span>
            </div>
            {showError(field.name)}
          </div>
        );
      }
      case 'date': {
        const { minDate, maxDate } = getDateLimits(field);
        return (
          <div key={field.name}>
            <label htmlFor={field.name} className="block font-semibold mb-2 text-sm md:text-base">
              {field.label}
              {field.required && '*'}
            </label>
            <div className="relative">
              <input
                type="date"
                placeholder={field.label}
                {...commonProps}
                min={minDate}
                max={maxDate}
                ref={(e) => {
                  register(field.name, { required: field.required ? 'This field is required' : false }).ref(e);
                  if (field.type === 'date') dateInputRef.current = e;
                }}
                className={`hide-native-calendar w-full p-3 pr-10 border rounded-md outline-none bg-[#FBFCFF] text-[#33415599] ${errors[field.name] ? 'border-red-500' : 'border-[#8ACEFF]'} text-sm md:text-base h-12`}
              />
              <span
                className="pointer-events-auto absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                onClick={() => {
                  if (dateInputRef.current) {
                    if (dateInputRef.current.showPicker) {
                      dateInputRef.current.showPicker();
                    } else {
                      dateInputRef.current.focus();
                    }
                  }
                }}
              >
                <Image src={calendar} alt="calendar icon" width={20} height={20} />
              </span>
            </div>
            {showError(field.name)}
          </div>
        );
      }
      default:
        return null;
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="w-full max-w-md mt-6">
        <div className="space-y-4">
          {fields.map(renderField)}
          {mutationError && (
            <div className="text-red-500 text-sm mb-2">Error booking slot. Please try again.</div>
          )}
        </div>
        <hr className="border-t-[1px] lg:hidden mt-24" />
        <button
          type="submit"
          className="w-full bg-[#0267B1] text-white font-semibold py-3 md:py-4 rounded-lg transition text-base mt-3 md:mt-10 mb-0 lg:mb-2"
          disabled={mutationLoading}
        >
          {mutationLoading && 'Booking...'}
          {!mutationLoading && (slotBookings ? 'Reschedule Appointment' : 'Schedule Appointment')}
        </button>
      </form>
      {isPopupOpen && (
        <SuccessFormPopup
          isOpen={isPopupOpen}
          onClose={handleRefetchBookingData}
          title="Appointment Booked"
          message={msg}
          isPageNotRedirect
          pageType="slot-booking"
          type="3"
          date={watch('slotDate') || slotBookings?.slotDate}
          time={
            watch('slotTime')
            || slotBookings?.slotTime
            || (domainName?.organizationName === 'nextias' ? '00:00' : '')
          }
          mode={watch('mode') || slotBookings?.mode}
          center={centerDisplay}
        />
      )}
    </>
  );
}

SlotBookingForm.propTypes = {
  slotBookingData: PropTypes.shape({
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string,
        type: PropTypes.string,
        required: PropTypes.bool,
        options: PropTypes.array,
        visibleIf: PropTypes.shape({
          field: PropTypes.string,
          equals: PropTypes.any,
        }),
        minDate: PropTypes.string,
        maxOffsetDays: PropTypes.number,
      }),
    ),
    slotTime: PropTypes.object,
    validFor: PropTypes.string,
  }),
  slotBookings: PropTypes.shape({
    slotDate: PropTypes.string,
    slotTime: PropTypes.string,
    mode: PropTypes.string,
    center: PropTypes.string,
    course: PropTypes.string,
    createdAt: PropTypes.number,
  }),
  domainName: PropTypes.shape({
    organizationName: PropTypes.string,
  }),
  refetch: PropTypes.func,
};

export default SlotBookingForm;
